import { useAuth } from '@/auth/AuthContext';
import LoginModal from '@/auth/LoginModal';

// ProtectedRoute — two-state guard around any RADAR page.
//   • 'checking'  → bare spinner, no flash of modal
//   • 'unauthed'  → render LoginModal (the only entry path)
//   • 'ready'     → render the protected children
export default function ProtectedRoute({ children }) {
  const { status } = useAuth();

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-checking">
        <div className="inline-block animate-spin rounded-full h-9 w-9 border-2 border-primary border-t-transparent" />
      </div>
    );
  }
  if (status === 'unauthed') {
    return <LoginModal open />;
  }
  return children;
}
